export const TIPO_ASIGNACION_EXCEDENTE = "Excedente";
export const TIPO_ASIGNACION_VOLANTE = "Sin aula asignada";
export const TIPO_ASIGNACION_TEMPORAL = "Temporal";
export const TIPO_ASIGNACION_ASIGNAR_VACANTE = "Asignar a Vacante";
